import React, { useEffect, useState } from "react";
import SkillCard from "../../components/Common/CommonCard";
import ReusableTable from "../../components/Common/BaseTable";
import { useNavigate } from "react-router-dom";
import ActionMenu from "../../components/ProductDescription/ActionMenu";
import { MoreHorizontal } from "lucide-react";
import newMessageIcon from "../../assets/newMessage.png";
import Breadcrumb from "../../components/Common/Bredcrump";
import { fetchEmailTemplates, deleteEmailTemplate, updateOrCreateEmailTemplate , updateEmailTemplateStatus} from "../../services/email";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
const Email = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [showModal, setShowModal] = useState(false);
  const [actionMenuOpen, setActionMenuOpen] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_pages: 1,
    total_count: 0,
    next_page: 0,
    prev_page: 0
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [sortType, setSortType] = useState("default");
  const [filterColumn, setFilterColumn] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [total, setTotal] = useState(0);
  const [draftId, setDraftId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetchEmailTemplates({
          sort_type: sortType,
          filter_column: filterColumn,
          filter_value: filterValue,
          page: page,
          per_page: perPage
        });
        setData(response.data);
        setTotal(response.pagination.total_count);
        setPagination(response.pagination);
      } catch (error) {
        console.error("Failed to fetch data:", error);
        // toast.error("Failed to fetch email templates");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [sortType, filterValue, page, perPage]);

  // Handle server-side search
  const handleSearch = (searchValue) => {
    setFilterValue(searchValue);
    setPage(1); // Reset to first page on new search
  };

  // Handle server-side sort
  const handleSort = (sortOption) => {
    setSortType(sortOption);
    setPage(1); // Reset to first page on new sort
  };

  // Handle server-side pagination
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1); // Reset to first page when changing rows per page
  };

  const handleDelete = (selectedRows) => {
    console.log("Delete:", selectedRows);
  };
  const confirmDelete = async () => {
    try {
      await deleteEmailTemplate(selectedDocument.id);
      toast.success("Email template deleted successfully");
      setPage(1); // Refetch data - reset to first page
      setShowModal(false); // Close modal
    } catch (error) {
      toast.error("Failed to delete email template");
      setShowModal(false);
    }
  };
  const handleDuplicate = (selectedRows) => {
    console.log("Duplicate:", selectedRows);
  };

  const handleMenuClick = (event, rowIndex) => {
    event.stopPropagation();
    const rect = event.target.getBoundingClientRect();
    setMenuPosition({ x: rect.left, y: rect.bottom });
    setMenuOpen(menuOpen === rowIndex ? null : rowIndex);
  };

  const handleMenuOption = (action, rowData) => {
    console.log(`${action} clicked for`, rowData);
    setMenuOpen(null);
  };

  const handleAction = async (action, document) => {
    setActionMenuOpen(null);
    setSelectedDocument(document);

    switch (action) {
      case "preview":
        localStorage.setItem("last_saved_draft_id", document.id);
        navigate(`/skills/email/preview-email`);
        break;
      case "edit":
        localStorage.setItem("last_saved_draft_id", document.id);
        navigate(`/skills/email/edit-email`);
        break;
      case "document":
        setShowModal(true);
        break;
      case "publish":
        try {
          await  updateEmailTemplateStatus(document.id, "publish");
          toast.success("Email template published successfully");
          setPage(1); // Reset to first page to refetch data
        } catch (error) {
          toast.error("Failed to publish email template");
        }
        break;
        case "delete":
          setSelectedDocument(document); // Save which one to delete
          setShowModal(true); // Show confirmation modal
          break;
      default:
        break;
    }
  };

  const skills = [{ title: "Email", icon: newMessageIcon }];

  const columns = [
    {
      id: "selection",
      header: ({ table }) => (
        <input
          type="checkbox"
          checked={table.getIsAllPageRowsSelected()}
          onChange={() => table.toggleAllPageRowsSelected()}
        />
      ),
      cell: ({ row }) => (
        <input
          type="checkbox"
          checked={row.getIsSelected()}
          onChange={() => row.toggleSelected()}
        />
      ),
      size: "5%",
    },
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "tone",
      header: "Tone",
    },
    {
      accessorKey: "occasion",
      header: "Occasion",
    },
    {
      accessorKey: "further_details",
      header: "Further Details",
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ getValue }) => {
        const status = getValue();
        const statusClass =
          status === "publish" ? "status-published" : "status-draft";
        const dotColor = status === "publish" ? "green" : "grey";
        return (
          <span className={`status-badge ${statusClass}`}>
            <span style={{ color: dotColor, marginRight: '5px' }}>•</span>
            {status}
          </span>
        );
      },
    },
    {
      accessorKey: "created_at",
      header: "Created",
      cell: ({ getValue }) => {
        const rawDate = getValue();
        const formattedDate = new Date(rawDate).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
        return formattedDate;
      },
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const handleActionClick = (e) => {
          e.stopPropagation();
          setActionMenuOpen(actionMenuOpen === row.original.id ? null : row.original.id);
          
          const closeMenu = (event) => {
            if (!event.target.closest('.position-relative')) {
              setActionMenuOpen(null);
              document.removeEventListener('click', closeMenu);
            }
          };
          
          setTimeout(() => {
            document.addEventListener('click', closeMenu);
          }, 0);
        };

        return (
          < >
            <button
              className="action-button btn"
              onClick={handleActionClick}
            >
              <MoreHorizontal size={20} />
            </button>
            {actionMenuOpen === row.original.id && (
              <ActionMenu
                onAction={(action) => handleAction(action, row.original)}
              />
            )}
          </>
        );
      },
    },
  ];

  const handleSkillClick = (title) => {
    console.log("HandleSkillClick");
    navigate("/skills/email/email-template");
  };

  return (
    <div>
      <Breadcrumb />
      <div
        className="skills-container"
        style={{ display: "flex", gap: "16px", marginTop: "5px" }}
      >
        {skills.map((skill) => (
          <SkillCard
            key={skill?.title}
            icon={skill.icon}
            title={skill.title}
            onClick={() => handleSkillClick(skill.title)}
          />
        ))}
      </div>
      <div className="headertop d-flex justify-content-between align-items-center">
        <div className="title-table-header">Generated Content</div>
        <button
          className="btn text-light"
          style={{ backgroundColor: 'var(--primary)' }}
          onClick={() => navigate('/skills/email/email-template')}
        >+ Generate Email</button>
      </div>
      <div className="mt-3 border rounded">
        <ReusableTable
          data={data}
          columns={columns}
          onSearch={handleSearch}
          onDelete={handleDelete}
          onDuplicate={handleDuplicate}
          gridView={false}
          isLoading={loading}
          page={page}
          perPage={perPage}
          total={total}
          onPageChange={handlePageChange}
          onPerPageChange={handlePerPageChange}
          onSort={handleSort}
          useServerPagination={true}
          filterColumn={filterColumn}
          setFilterColumn={setFilterColumn}
          filterValue={filterValue}
          setFilterValue={setFilterValue}
        />
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton>
            <Modal.Title>Delete Email Template</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <h5 className="text-center pt-0">Are you sure you want to delete this email template?</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Email;